import { Box, Center } from "@chakra-ui/react";
import React, { ReactElement, useState } from "react";

import backgroundImageUrl from "../../assets/images/tateshina/Meter_Frame_up8.png";
import needleImageUrl from "../../assets/images/tateshina/Meter_Needle_up19.png";

interface MeterDisplayProps {
  backgroundImage?: string;
  needleImage?: string;
  value: number;
  minValue?: number;
  maxValue?: number;
}

const MeterDisplay: React.FC<MeterDisplayProps> = ({
  backgroundImage = backgroundImageUrl,
  needleImage = needleImageUrl,
  value,
  minValue = 0,
  maxValue = 100,
}) => {
  // 値を角度に変換する関数
  const calculateRotation = (
    currentValue: number,
    min: number,
    max: number
  ): number => {
    const percentage: number = (currentValue - min) / (max - min);
    const startAngle = -130; // 左端
    const endAngle = 130; // 右端
    return startAngle + percentage * (endAngle - startAngle);
  };

  const needleRotation: number = calculateRotation(value, minValue, maxValue);

  return (
    <Box
      sx={{
        ".record_sample_box": {
          position: "relative",
          height: "340px",
          marginBottom: "20px",
          maxWidth: "400px",
          margin: "0 auto 20px auto",
        },
        ".record_sample_box img": {
          position: "absolute",
        },
        ".record_sample_img": {
          top: "4px",
          height: "100%",
          width: "100%",
          objectFit: "contain",
        },
        ".needle_img": {
          top: "4px",
          height: "100%",
          width: "100%",
          objectFit: "contain",
          transformOrigin: "center center",
          transition: "transform 0.3s ease-in-out",
          transform: `rotate(${needleRotation}deg)`,
        },
        "@media (max-width: 768px)": {
          ".record_sample_box": {
            height: "300px",
            marginBottom: "40px",
          },
        },
        "@media (max-width: 480px)": {
          ".record_sample_box": {
            height: "250px",
            marginBottom: "30px",
          },
        },
      }}
    >
      <Box className="record_sample_box">
        <Center>
          {/* 背景メーター画像 */}
          <img
            className="record_sample_img"
            src={backgroundImage}
            alt="メーター背景"
          />
          {/* 針画像 */}
          <img className="needle_img" src={needleImage} alt="メーター針" />
        </Center>
      </Box>
    </Box>
  );
};

export function MeterDisplayDemo(): ReactElement {
  const [value, setValue] = useState("50");
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
  };
  const button_style = {
    marginLeft: "8px",
    padding: "4px 8px",
    backgroundColor: "#a0a0a0",
    border: "1px solid #333",
    borderRadius: "4px",
    width: "50px",
  };
  return (
    <>
      <MeterDisplay value={Number(value)} />
      <input
        type="number"
        id="number"
        min="0"
        max="100"
        step="1"
        value={value}
        onChange={handleChange}
        placeholder="例: 60"
        style={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "8px",
          width: "80px",
        }}
      />
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <button onClick={() => setValue("0")} style={button_style}>
          0
        </button>
        <button onClick={() => setValue("15")} style={button_style}>
          15
        </button>
        <button onClick={() => setValue("33")} style={button_style}>
          33
        </button>
        <button onClick={() => setValue("50")} style={button_style}>
          50
        </button>
        <button onClick={() => setValue("66")} style={button_style}>
          66
        </button>
        <button onClick={() => setValue("85")} style={button_style}>
          85
        </button>
        <button onClick={() => setValue("100")} style={button_style}>
          100
        </button>
      </div>
    </>
  );
}

export default MeterDisplay;
